import React, { ReactElement } from 'react';
import IconBlockSuccess from '../../../components/icon-block-success/icon-block-success.component';
import StatusIconBlock from '../../../components/status-icon-block/status-icon-block.component';
import { DEAL_TASK_STATUS_APPROVED } from '../../../constants/entity/deal-task-statuses';

const DealTaskReviewStatusIcon: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    dealTaskReview,
  } = props;

  let icon: ReactElement | null = null;
  let title: string = '';

  if (dealTaskReview.status === DEAL_TASK_STATUS_APPROVED) {
    icon = <IconBlockSuccess />;
    title = 'Approved';
  }

  return (
    <StatusIconBlock title={title}>
      {icon}
    </StatusIconBlock>
  );
});

export default DealTaskReviewStatusIcon;
